import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Statistic, getValue } from './Statistics';

export default function PortfolioStatistics({ statistics }: { statistics: Statistic[] }) {
  return (
    <div className="my-8">
      <dl className="flex flex-row flex-wrap justify-center gap-x-8 gap-y-6 my-8">
        {statistics.map(stat => (
          <div
            key={stat.label}
            className="flex flex-col justify-between items-center p-6 border-2 border-b-gray-300 border-r-gray-300 rounded-2xl"
          >
            <dt className="text-sm font-semibold text-gray-600 leading-tight mt-1 flex items-center gap-1">
              {stat.label}
              {stat.helperText && (
                <div className="group relative">
                  <InformationCircleIcon className="h-4 w-4 text-gray-400" />
                  <div
                    className="invisible group-hover:visible absolute z-50 w-fit min-w-32 bg-indigo-600 text-white text-xs text-left rounded p-2 -right-2 -top-8"
                    style={{ transform: 'translateZ(0)' }}
                  >
                    {stat.helperText}
                    <div className="absolute -bottom-1 right-3 w-2 h-2 bg-indigo-600 rotate-45" />
                  </div>
                </div>
              )}
            </dt>
            <dd className="order-first text-xl font-semibold tracking-tight text-gray-900 whitespace-nowrap">
              {getValue(stat.value, stat.type, stat.navigateTo, stat.customValue)}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
